import { useState, useEffect } from 'react';

interface FloatingEmoji {
  id: number;
  emoji: string;
  from: string;
  left: number;
}

export default function ReactionOverlay({ latestReaction }: { latestReaction?: { emoji: string, from: string } | null }) {
  const [emojis, setEmojis] = useState<FloatingEmoji[]>([]);

  useEffect(() => {
    if (latestReaction) {
      const id = Date.now();
      const left = 20 + Math.random() * 60; // 20% to 80%
      setEmojis(prev => [...prev, { id, ...latestReaction, left }]);

      // Remove after animation completes
      setTimeout(() => {
        setEmojis(prev => prev.filter(e => e.id !== id));
      }, 3000);
    }
  }, [latestReaction]);

  return (
    <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
      {emojis.map(e => (
        <div
          key={e.id}
          className="absolute bottom-0 flex flex-col items-center animate-reaction-float"
          style={{ left: `${e.left}%` }}
        >
          <span className="text-4xl filter drop-shadow-lg">{e.emoji}</span>
          <span className="text-[10px] font-bold text-white/60 bg-black/20 px-1.5 rounded-full backdrop-blur-sm whitespace-nowrap">
            {e.from}
          </span>
        </div>
      ))}
    </div>
  );
}
